import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { BookAppointmentResponse, UdateDetailsResponse } from '../types';
import { showNotification } from '@/utils/notificationUtils';
import { Customers, Pets } from '@/features/customers';
import { RecurringDetails } from '@/features/Calendar/types';
import { RecurringAppointment } from './getRecurringSlots';
export type BookAppointmentDTO = {
  data: {
    allowHoliday?: boolean;
    allowNonBusinessHours?: boolean;
    name?: string;
    summary?: string;
    description?: string;
    email?: string;
    phone: string;
    serviceId: number;
    businessUserId: number;
    startTime: Date;
    endTime: Date;
    tz: string;
    businessId: number | undefined;
    address?: string;
    zip?: string;
    state?: string;
    city?: string;
    petId?: number | null;
    duration: number;
    country?: string;
    petDetails?: Pets[];
    roomId: number;
    addonSids: number[] | undefined;
    startDate?: any;
    endDate?: any;
    petCount: number;
    isRecurring?: boolean;
    recurringFrequency?: string;
    recurringCount?: any;
    slotsToBook?: RecurringAppointment[];
    additionalGroomers?: number[];
  };
};

export const bookAppointment = ({ data }: BookAppointmentDTO): Promise<BookAppointmentResponse> => {
  return axios.post(
    data.startDate
      ? `/rooms/${data.roomId}/boarding/book`
      : data.roomId
        ? `/rooms/${data.roomId}/daycare/book`
        : `/business/calendar/appointment`,
    data
  );
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof bookAppointment>;
};

export const useBookAppointMent = ({ config }: UseUpdateBusinessOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      // showNotification({
      //   type: 'success',
      //   title: 'Appointment booked successfully',
      // });
    },
    ...config,
    mutationFn: bookAppointment,
  });
};

export type UpdateDTO = {
  altEmails?: string[];
  altPhone?: string;
  address: string;
  city?: string;
  state?: string;
  zip?: string;
  id?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  name?: string;
  businessId?: any;
  businessLocationId?: any;
  country?: string;
  apt?: string;
  defaultBusinessUserId?: any;
  optOutSms?: boolean;
  optOutIvr?: boolean;
  optOutEmail?: boolean;
};

export const updateOwnerDetails = ({
  altEmails,
  altPhone,
  address,
  city,
  state,
  zip,
  id,
  phone,
  firstName,
  lastName,
  email,
  name,
  businessId,
  businessLocationId,
  country,
  apt,
  defaultBusinessUserId,
  optOutSms,
  optOutIvr,
  optOutEmail,
}: UpdateDTO): Promise<Customers> => {
  return axios.post(`/business/update-parent`, {
    altEmails,
    altPhone,
    address,
    city,
    state,
    zip,
    id,
    phone,
    firstName,
    lastName,
    email,
    name,
    businessId,
    businessLocationId,
    country,
    apt,
    defaultBusinessUserId,
    optOutSms,
    optOutIvr,
    optOutEmail,
  });
};

type UseUpdateOwnerDetails = {
  config?: MutationConfig<typeof updateOwnerDetails>;
};

export const useUpdateOwnerDetails = ({ config }: UseUpdateOwnerDetails = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Owner details updated successfully.',
      });
    },
    ...config,
    mutationFn: updateOwnerDetails,
  });
};
